import React from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import { useUpdateInstrumentMutation } from "../../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup"
import TextInput from "../../../../../../Common/components/text-input";
import TextAreaInput from "../../../../../../Common/components/text-area-input";
import DateInput from "../../../../../../Common/components/date-input";

export const EditInstrumentModal = ({ show, onHide, details }) => {
    const [
        updateInstrument, // This is the mutation trigger
        {
            isLoading: isUpdating
        }, // This is the destructured mutation result
    ] = useUpdateInstrumentMutation()

    /* Change User Group */
    const onSubmit = (values) => {
        updateInstrument({
            id: details.id,
            ...values,
            meta: details,
        })
        .unwrap()
        .then(() => {
            cogoToast.success("Created 'Update Instrument' Action Successfully")
            onHide()
        })
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Formik
                initialValues={{
                    symbol: details?.symbol,
                    name: details?.name,
                    description: details?.description,
                    category: details?.category,
                    url: details?.url,
                    listdate: details?.listdate,
                    phone: details?.meta?.phone,
                    address: details?.meta?.address,
                    ceo: details?.meta?.ceo,
                }}
                validationSchema={
                    Yup.object({
                        symbol: Yup.string().required("required"),
                        name: Yup.string().required("required"),
                        description: Yup.string().required("required"),
                        category: Yup.string().required("required"),
                        url: Yup.string().required("required"),
                        listdate: Yup.date().required("required"),
                        phone: Yup.string().required("required"),
                        address: Yup.string().required("required"),
                        ceo: Yup.string().required("required"),
                    })
                }
                onSubmit={(values) => onSubmit(values)}
            >
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {`Edit ${details?.symbol}`}
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>

                    <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                    <FormLayout.Row>
                            <TextInput
                                label="Symbol*"
                                name="symbol"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Name*"
                                name="name"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextAreaInput
                                label="Description*"
                                name="description"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Category*"
                                name="category"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <DateInput
                                label="List Date*"
                                name="listdate"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Website*"
                                name="url"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="CEO*"
                                name="ceo"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Phone*"
                                name="phone"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextAreaInput
                                label="Address*"
                                name="address"
                            />
                        </FormLayout.Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            disabled={isUpdating}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isUpdating}
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Update
                        </button>
                    </Modal.Footer>
                </Form>
            </Formik>
        </Modal >
    );
}
